// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"327":"Products","869":"Config"}[chunkId] || chunkId) + "." + {"197":"ff92bb93","327":"8a5667fd","642":"4d028f7b","745":"1501b2d1","869":"c8ea44a6","942":"11c83bfc"}[chunkId] + ".css";
};